import { Component, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EditInvoiceSettingsDialogContentComponent } from './edit-invoice-settings-dialog-content/edit-invoice-settings-dialog-content.component';

@Component({
  selector: 'app-edit-invoice-settings-dialog',
  template: ''
})
export class EditInvoiceSettingsDialogComponent implements OnDestroy {

  private modal: NgbModalRef | null = null
  
  constructor(
    public modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
  }

  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }
    
    this.modal = this.modalService.open(
      EditInvoiceSettingsDialogContentComponent,
      { centered: true, backdrop: 'static', size: 'xl' }
    )

    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    this.modal.componentInstance.customerId = customerId;

    this.modal.result.then(toDashboard => {
      if (toDashboard) window.history.go(-2)
      else this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
